import { apiDelete, apiGet, apiPost } from './client';

/**
 * Broker invites (gateway routes/broker-agents.ts): the agent gets an account OF THEIR OWN, linked
 * to the broker. On Brokerage Growth it is included; on an agent plan the agent pays.
 */
export interface BrokerInvite {
  id: string;
  email: string;
  agent_name: string | null;
  included: boolean;
  status: 'pending' | 'accepted' | 'cancelled';
  expires_at: string;
  created_at: string;
}

export interface BrokerAgent {
  tenant_id: string;
  slug: string;
  plan: string;
  included: boolean;
  email: string | null;
  created_at: string;
}

export interface BrokerAgentsList {
  agents: BrokerAgent[];
  invites: BrokerInvite[];
  /** True while this account is on the broker plan: new agent accounts are included. */
  includes_agents: boolean;
}

export const listBrokerAgents = () => apiGet<BrokerAgentsList>('/broker/agents');

export const inviteBrokerAgent = (body: { email: string; name?: string }) =>
  apiPost<{ invite: BrokerInvite; invite_link: string }>('/broker/agent-invites', body);

export const cancelBrokerInvite = (id: string) => apiDelete<{ cancelled: boolean }>(`/broker/agent-invites/${id}`);

export interface BrokerInvitePreview {
  email: string;
  name: string | null;
  broker_name: string;
  included: boolean;
}

export const previewBrokerInvite = (token: string) => apiGet<BrokerInvitePreview>('/broker/agent-invites/preview', { token });

/** Makes the agent's account and signs them in (session cookies); hydrate from /auth/me after. */
export const acceptBrokerInvite = (body: { token: string; password: string; slug: string; name?: string }) =>
  apiPost<{ ok: boolean; plan: string; included: boolean }>('/broker/agent-invites/accept', body);
